export enum RiskLevelEnum {
  Easy = 'קלה (LH)',
  Regular1 = 'רגיל 1 (OH1) ',
  Regular2 = 'רגיל 2 (OH2)',
  High1 = 'גבוה 1 (EH1)',
  High2 = 'גבוה 2 (EH2)',
  SpecialRisk = 'תפוסת סיכון מיוחדת (SO)',
  Storage = 'אחסון'
}
